import { render } from "./InfoRichiestaRimborsi.vue?vue&type=template&id=1ab4ad2d&scoped=true"
import script from "./InfoRichiestaRimborsi.vue?vue&type=script&lang=js"
export * from "./InfoRichiestaRimborsi.vue?vue&type=script&lang=js"

import "./InfoRichiestaRimborsi.vue?vue&type=style&index=0&id=1ab4ad2d&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab4ad2d"]])

export default __exports__